import { flow, Runtime } from "fp";

import * as Data from "~/Data";
import * as Messaging from "~/Messaging";
import { Request } from "~/Request";

export namespace Get {
  export const request = (
    company: Data.Reference.Reference
  ): Data.Cache.Request<Messaging.Summary.Summary> =>
    flow(
      Request.fromConfig({
        endpoint: `/elogs/companies/${company.id}/messages-summary`,
      }),
      Request.Expect.status(200),
      Request.Expect.json(Runtime.array(Messaging.Summary.Response.runtime())),
      Request.onSuccess(
        Data.Cache.fromList(
          flow(Messaging.Summary.Response.decode, (summary) => [
            summary.id,
            summary,
          ])
        )
      )
    );
}
